export const EMAIL_VERIFY_BY_CODE = "EMAIL_VERIFY_BY_CODE";

export default function setEmailVerifyByCode(emailAddress, isSent) {
  return {
    type: EMAIL_VERIFY_BY_CODE,
    payload: { email: emailAddress, isSent },
  };
}
